import { render, staticRenderFns } from "./UpdateStaffPopUp.vue?vue&type=template&id=5ff9d0a7&scoped=true"
import script from "./UpdateStaffPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateStaffPopUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateStaffPopUp.vue?vue&type=style&index=0&id=5ff9d0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9d0a7",
  null
  
)

export default component.exports